import 'vanilla-cookieconsent/src/cookieconsent.js';
import 'vanilla-cookieconsent/src/cookieconsent.css';
import '../scss/iframemanager.css'
window.addEventListener('load', function(){

    // obtain plugin
    var cc = initCookieConsent();

    // run plugin with your configuration
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,                   // default: false
        page_scripts: true,                        // default: false

        // mode: 'opt-in'                          // default: 'opt-in'; value: 'opt-in' or 'opt-out'
        // delay: 0,                               // default: 0
        // auto_language: '',                      // default: null; could also be 'browser' or 'document'
        // autorun: true,                          // default: true
        // force_consent: false,                   // default: false
        // hide_from_bots: true,                   // default: true
        // remove_cookie_tables: false             // default: false
        // cookie_name: 'cc_cookie',               // default: 'cc_cookie'
        // cookie_expiration: 182,                 // default: 182 (days)
        // cookie_necessary_only_expiration: 182   // default: disabled
        // cookie_domain: location.hostname,       // default: current domain
        // cookie_path: '/',                       // default: root
        // cookie_same_site: 'Lax',                // default: 'Lax'
        // use_rfc_cookie: false,                  // default: false
        // revision: 0,                            // default: 0

        onFirstAction: function(user_preferences, cookie){
            // callback triggered only once on the first accept/reject action
        },

        onAccept: function (cookie) {
            // callback triggered on the first accept/reject action, and after each page load
        },

        onChange: function (cookie, changed_categories) {
            // callback triggered when user changes preferences after consent has already been given
        },

        languages: {
            'de': {
                consent_modal: {
                    title: 'Wir nutzen Cookies!',
                    description: 'Hallo, diese Website verwendet erforderliche Cookies, um den einwandfreien Betrieb sicherzustellen, sowie Tracking-Cookies, um zu sehen, wie Sie damit interagieren. Letztere werden nur nach Zustimmung gesetzt. <button type="button" data-cc="c-settings" class="cc-link">Einstellungen konfigurieren</button>.',
                    primary_btn: {
                        text: 'Alle akzeptieren',
                        role: 'accept_all'              // 'accept_selected' or 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Alle ablehnen',
                        role: 'accept_necessary'        // 'settings' or 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie-Einstellungen konfigurieren',
                    save_settings_btn: 'Einstellungen speichern',
                    accept_all_btn: 'Alle akzeptieren',
                    reject_all_btn: 'Alle ablehnen',
                    close_btn_label: 'Schließen',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Ablauf'},
                        {col4: 'Beschreibung'}
                    ],
                    blocks: [
                        {
                            title: 'Cookie-Nutzung',
                            description: 'Diese Website verwendet Cookies, um grundlegende Funktionen sicherzustellen und Ihr Online-Erlebnis zu verbessern. Sie können jederzeit die Zustimmung für jede Kategorie einzeln verwalten bzw. nachträglich ändern. Für weitere Details zu Cookies und anderen sensiblen Daten lesen Sie bitte die vollständige <a href="/de/datenschutz" class="cc-link">Datenschutzrichtlinie</a>.'
                        }, {
                            title: 'Statistiken',
                            description: 'Diese Cookies ermöglichen es der Website, sich an die Auswahl zu erinnern, die Sie in der Vergangenheit getroffen haben.',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: '_pk_id',
                                    col2: 'matomo.org',
                                    col3: '2 Jahre',
                                    col4: 'Beschreibung ...',
                                    is_regex: true
                                },
                                {
                                    col1: '_pk_ses',
                                    col2: 'matomo.org',
                                    col3: '1 Tag',
                                    col4: 'Beschreibung ...',
                                },
                                {
                                    col1: 'cc_cookie',
                                    col2: 'matomo.org',
                                    col3: '2 Jahre',
                                    col4: 'Beschreibung ...',
                                }
                            ]
                        }, {
                            title: 'Mehr Informationen',
                            description: '<a class="cc-link" href="/de/impressum">Kontaktieren Sie uns</a> gerne bei Fragen zu unserer Cookie-Richtlinie und Ihren Auswahlmöglichkeiten.',
                        }
                    ]
                }
            }
        }
    });

    const im = iframemanager();

    im.run({
        currLang: 'de',
        services : {
            youtube : {
                embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
                thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
                iframe : {
                    allow : 'fullscreen; encrypted-media',
                    frameborder: '0',
                },
                languages : {
                    en : {
                        notice: 'Dieser Inhalt wird von einem Drittanbieter gehostet. Durch die Anzeige des externen Inhalts akzeptieren Sie die <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">Nutzungsbedingungen</a> von YouTube.',
                        loadBtn: 'Video abspielen',
                        loadAllBtn: "Nicht mehr fragen"
                    }
                }
            },
            soundcloud : {
                embedUrl: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/629303448&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true',
                thumbnailUrl: 'https://i1.sndcdn.com/avatars-ePYjzGEglj6ASXUe-xYPcRg-t500x500.jpg',
                iframe : {
                    allow : 'fullscreen; autoplay;',
                    frameborder: '0',
                },
                languages : {
                    en : {
                        notice: 'Dieser Inhalt wird von einem Drittanbieter gehostet. Durch die Anzeige des externen Inhalts akzeptieren Sie die <a rel="noreferrer noopener" href="https://soundcloud.com/terms-of-use" target="_blank">Nutzungsbedingungen</a> von SoundCloud.',
                        loadBtn: 'Podcast abspielen',
                        loadAllBtn: "Nicht mehr fragen"
                    }
                }
            },
            googlemaps : {
                embedUrl: 'https://www.google.com/maps/embed?pb={data-id}',

                iframe: {
                    allow : 'picture-in-picture; fullscreen;',
                    frameborder: '0',
                    style: 'border: 0;'
                },

                languages : {
                    en : {
                        notice: 'Dieser Inhalt wird von einem Drittanbieter gehostet. Durch die Anzeige des externen Inhalts akzeptieren Sie die <a rel="noreferrer noopener" href="https://cloud.google.com/maps-platform/terms" target="_blank">Nutzungsbedingungen</a> von Google Maps.',
                        loadBtn: 'Karte anzeigen',
                        loadAllBtn: "Nicht mehr fragen"
                    }
                }
            },
        }
    });
});


// WEBPACK FOOTER //
// ./frontend/js/cookieconsent.js